import { SVGAttributes } from 'react';

type Props = SVGAttributes<SVGElement>;

export function BrandHandMarkTwoLinesVariant5(props: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="143"
            height="8"
            viewBox="0 0 143 8"
            fill="currentColor"
            {...props}
        >
            <path d="M143 6.80689C142.844 7.14605 142.184 7.20056 141.549 7.20661C139.449 7.22478 134.201 6.39506 131.389 6.23759C111.004 5.12322 86.0834 5.87419 65.4394 6.41321C50.5752 6.80082 34.2466 7.99394 19.6028 8C18.4364 8 15.2614 7.87281 14.134 7.78802C13.3694 7.72746 13.2009 7.64873 13.0843 7.29746C12.9288 6.83717 13.512 7.03703 14.147 7.00674C18.1384 6.81294 22.078 6.27999 26.0046 5.8621L26.9636 6.21336L16.8813 7.39436C24.3069 7.67901 31.603 7.03703 38.9508 6.80689C65.4523 5.97717 95.0381 4.75983 121.371 5.41997C128.693 5.60167 135.859 6.09829 143 6.80689Z" />
            <path d="M124.08 0.708115C123.458 1.08967 121.164 0.726283 120.464 0.726283C103.163 0.683889 85.3057 1.27136 67.9534 1.68925C53.5298 2.03446 39.0026 2.45841 24.6568 3.26391C16.8425 3.70602 8.89847 4.25715 1.31735 5.22617L4.25911 6.20126C3.23534 6.21337 1.90054 6.09223 1.01932 5.84998C-1.7669 5.08687 1.88758 4.69321 3.32605 4.48729C7.39523 3.90588 12.8769 3.57885 17.1535 3.28814C47.3483 1.24714 77.9449 1.27136 108.295 0.102477C112.675 0.375014 118.883 -0.242744 123.03 0.114583C123.665 0.16909 124.481 0.453741 124.08 0.702053V0.708115Z" />
        </svg>
    );
}
